import { Box, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useProductionTableData } from "./hooks/useProductionTableData";

import { useState } from "react";
import { useCastersContext } from "../../../CastersContext";
import { useTableStyles } from "../../../styles/useTableStyles";
import { EditStrandModal } from "./modals/EditStrandModal";

export const ProductionTable = ({
	refresh,
	readonly,
}: {
	refresh: Function;
	readonly: boolean;
}) => {
	const { state, actions } = useCastersContext();
	const [strandToEdit, setStrandToEdit] = useState<number | null>(null);
	const [showEditModal, setShowEditModal] = useState(false);
	const classes = useTableStyles();
	const strands = state.strands || [];
	const process = state.processData || null;

	const handleEditStrand = (strandId: number | null) => {
		actions.setRefreshInPause(true);
		setStrandToEdit(strandId);
		setShowEditModal(true);
	};

	const { columns, rowData, statusBar } = useProductionTableData({
		strands: strands,
		processData: process,
		editCallback: handleEditStrand,
		readonly: readonly || !process?.HeatId,
	});

	return (
		<>
			<Paper className={classes.borderAgGridTable} elevation={0}>
				<Box p={0}>
					<div
						className={`${classes.materialTable}`}
						style={{ height: "14rem" }}
					>
						<AgGridReact
							rowData={rowData}
							columnDefs={columns}
							domLayout="normal"
							suppressRowClickSelection={true}
							suppressPaginationPanel={true}
							getRowId={(params) => params.data.Strand}
							statusBar={statusBar}
						/>
					</div>
				</Box>
			</Paper>
			<EditStrandModal
				show={showEditModal}
				onHide={(shouldUpdate) => {
					if (shouldUpdate) {
						refresh();
					}
					setStrandToEdit(null);
					setShowEditModal(false);
					actions.setRefreshInPause(false);
				}}
				strandId={strandToEdit}
			/>
		</>
	);
};
